import axios from 'axios';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { PulseLoader } from 'react-spinners';
import { toast } from 'react-toastify';
import { Button, Row, Card, CardBody, CardFooter, CardHeader, CardImg, Col, Container, Form, FormGroup, Input, InputGroup, InputGroupText, Label, Modal, ModalBody, ModalFooter } from 'reactstrap';
import * as actions from '../../../store/actions/auth';
import { astrabrand } from '../../../variables/ColorPalette.js';
import { loadError } from "../../forms/inputValidationUtils/load_error.js";
import { updateUser } from "./userData/UserSaveUpdate.js";
import Terms from "./usermodals/Terms_Conditions.jsx";
import { withRouter } from "../../../components/Navigation/withRouter.js";

const queryString = require("query-string");

class ChangePassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      updating: false,
      TandC: false,
      saving: true,
      validPassword: true,
      showReqs: false,
      TermsandConditions: false,
      forgotPasswordReset: false,
      passwordTested: false,
    };
    this.keyPress = this.keyPress.bind(this);

    this.toggleTermsandConditions = this.toggleTermsandConditions.bind(this);
    this.redirectTimeout = null;
  }

  componentDidMount() {
    console.log("We mounted Change Password");
    this.props.onTryAutoSignup();
    // document.body.classList.toggle("login-page");
    let parsed = queryString.parse(this.props.location.search);
    if (parsed && parsed.token) {
      this.setState({
        forgotPasswordReset: true,
        token: parsed.token,
        TandC: parsed.token ? false : true,
        url: this.props.url,
      });
    } else if (this.props.token) {
      this.setState({
        header: {
          headers: {
            Authorization: `Token ${this.props.token}`,
          },
        },
        TandC: true,
        changePasswordUrl: this.props.changePasswordUrl,
        url: this.props.url,
        userId: this.props.userId,
      });
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.token !== this.props.token || this.props.changePasswordUrl !== newProps.changePasswordUrl) {
      this.setState({
        header: {
          headers: {
            Authorization: `Token ${newProps.token}`,
          },
        },
        TandC: true,
        changePasswordUrl: newProps.changePasswordUrl,
        url: newProps.url,
        userId: newProps.userId,
      });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.redirectTimeout);
    // document.body.classList.toggle("login-page");
    let id = window.setTimeout(null, 0);
    while (id--) {
      window.clearTimeout(id);
    }
  }
  toggleTermsandConditions() {
    this.setState({
      TermsandConditions: !this.state.TermsandConditions,
    });
  }
  handleClick = () => {
    this.setState({ TandC: !this.state.TandC });
  };

  handleSubmit = (e) => {
    let options;
    if (
      !this.state.passwordTested ||
      (this.state.password2 && !this.state.TandC) ||
      (this.state.password2 && this.state.password2 !== this.state.password1) ||
      this.state.passwordState === "has-danger"
    ) {
      options = {
        place: "tc",
        message: "Please Complete the Reset Process",
        type: "warning",
        icon: <i className={"tim-icons icon-alert-circle-exc"} />,
        autoClose: 7000,
      };

      toast[options.type](options.message, options);
    } else {
      e.preventDefault();
      this.setState({
        updating: true,
        saving: true,
      });

      if (this.state.password1 && this.state.password2) {
        const updated_pass = {
          password: this.state.password1,
          token: this.state.token,
        };

        if (this.state.forgotPasswordReset) {
          axios
            .post(this.state.url + "password_reset/confirm/", updated_pass)
            .then((res) => {
              this.setState({
                updating: false,
              });
              options = {
                place: "tc",
                message: "Successfully Reset Password. Transfering to Login Page",
                type: "success",
                icon: <i className={"tim-icons icon-alert-circle-exc"} />,
                autoClose: 10000,
              };

              toast[options.type](options.message, options);
              this.redirectTimeout = setTimeout(() => {
                this.props.navigate("/auth/login");
              }, 5000);
            })
            .catch((error) => {
              this.setState({
                updating: false,
                saving: false,
              });
              options = loadError(error);

              toast[options.type](options.message, options);
              this.handleFeedbackError("ERROR: Can't reset Password Successfully");
            });
        } else {
          const updated_pass = {
            new_password1: this.state.password1,
            new_password2: this.state.password2,
          };
          axios
            .post(this.state.changePasswordUrl, updated_pass, this.state.header)
            .then((res) => {
              //this.props.navigate('/auth/login');
              const newPasswordReset = {
                sso: false,
                password_reset_required: false,
              };
              updateUser(this.state.url, this.state.header, newPasswordReset, this.state.userId);

              axios
                .patch(this.state.url + `personnel/${this.state.userId}/`, newPasswordReset, this.state.header)
                .then((res) => {
                  this.props.navigate("/admin/dailyCall");
                })
                .catch((error) => {
                  this.handleFeedbackError("Error: Setting Single Sign On");
                  this.setState({
                    updating: false,
                    saving: false,
                  });
                  options = loadError(error);

                  toast[options.type](options.message, options);
                });
            })
            .catch((error) => {
              this.setState({
                updating: false,
                saving: false,
              });
              options = loadError(error);

              toast[options.type](options.message, options);
            });
        }
      }
    }
  };

  handleFeedbackError = (description) => {
    let options;
    let url = window.location.href;
    const feedback = {
      type: "CHANGE PASSWORD ERROR RECIEVED",
      submitter: 1,
      description: description,
      summary: this.state.token,
      active: true,
      url: url,
      priority: "NOW",
      media_file: null,
    };

    axios.post(this.state.url + "animo-feedback/", feedback, this.state.header).then((res) => {
      options = {
        place: "tc",
        message: "We have notified Support of this error and will get with you shortly",
        type: "secondary",
        icon: <i className={"tim-icons icon-alert-circle-exc"} />,
        autoClose: 7000,
      };
      toast[options.type](options.message, options);
    });
  };
  keyPress(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      this.handleSubmit(e);
      // put the login here
    }
  }
  isStrongPwd(password) {
    this.setState({ passwordTested: true });

    var regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{14,}/;

    var validPassword = regExp.test(password);

    return validPassword;
  }

  render() {
    let errorMessage = null;
    let { passwordState, password2State } = this.state;
    if (this.props.error) {
      passwordState = "has-danger";
      errorMessage = <p>{this.props.error.message}</p>;
    }

    return (
      <>
        <div className="content">
          <Container>
            <Col className="ml-auto mr-auto" lg="4" md="6">
              <Form className="form"></Form>
              <Form className="form">
                <Card className="card-login card-white">
                  {this.state.token ? (
                    <CardHeader style={{ marginBottom: 10 }}>
                      <Row className="justify-content-center">
                        <CardImg alt="..." src={require("../../../assets/img/Animo_word_logo.png")} width="90%" border="100" />
                        <br></br>
                      </Row>
                    </CardHeader>
                  ) : (
                    <h3 style={{ marginTop: 10, marginLeft: 15, color: astrabrand[6] }}>Change Password</h3>
                  )}
                  <Form>
                    {/* onSubmit={e => { this.handleSubmit(e) }} */}
                    <CardBody>
                      <FormGroup className={`has-label ${passwordState}`}>
                        <Label>New Password</Label>
                        <InputGroup>
                          <InputGroupText>
                            <i className="tim-icons icon-lock-circle" />
                          </InputGroupText>
                          <Input
                            placeholder="New Password"
                            type="Password"
                            onKeyDown={this.keyPress}
                            onBlur={(e) => {
                              this.isStrongPwd(e.target.value)
                                ? this.setState({ validPassword: true, saving: true, password1: e.target.value, passwordState: "has-success" })
                                : this.setState({ validPassword: false, saving: true, password1: e.target.value, passwordState: "has-danger" });
                            }}
                          />
                        </InputGroup>
                        {this.state.passwordState === "has-danger" ? <label className="error">Password is not secure.</label> : null}
                      </FormGroup>

                      <FormGroup className={`has-label ${password2State}`} style={{ marginTop: 10 }}>
                        <Label>Repeat Password</Label>
                        <InputGroup>
                          <InputGroupText>
                            <i className="tim-icons icon-lock-circle" />
                          </InputGroupText>
                          <Input
                            placeholder="Retype Password"
                            type="Password"
                            onKeyDown={this.keyPress}
                            onChange={(e) => {
                              this.setState({ saving: true, password2: e.target.value, password2State: "has-success" });
                            }}
                          />
                        </InputGroup>
                        {this.state.passwordState === "has-danger" ? <label className="error">This field is required.</label> : null}
                      </FormGroup>
                      {errorMessage}
                      {this.state.validPassword ? null : (
                        <div>
                          <h4 style={{ color: astrabrand[6] }}>Password Requirements:</h4>
                          <h6 style={{ color: astrabrand[6] }}>&nbsp;&nbsp;&nbsp;{"Min. 14 characters"} </h6>
                          <h6 style={{ color: astrabrand[6] }}>&nbsp;&nbsp;&nbsp;1 Each of:</h6>
                          <h5 style={{ color: astrabrand[6] }}>&nbsp;&nbsp;&nbsp;&nbsp;{"Capital Letter"} </h5>
                          <h5 style={{ color: astrabrand[6] }}>&nbsp;&nbsp;&nbsp;&nbsp;{"LowerCase Letter"} </h5>
                          <h5 style={{ color: astrabrand[6] }}>&nbsp;&nbsp;&nbsp;&nbsp;{"Number"} </h5>
                          <h5 style={{ color: astrabrand[6] }}>&nbsp;&nbsp;&nbsp;&nbsp;{"Special Character"} </h5>
                        </div>
                      )}
                    </CardBody>

                    <CardFooter>
                      <Button
                        disabled={
                          !this.state.passwordTested || (this.state.password2 && !this.state.TandC) || this.state.password2 !== this.state.password1 || this.state.passwordState === "has-danger"
                        }
                        type="submit"
                        block
                        className="mb-2"
                        color={this.state.password2 !== this.state.password1 ? "secondary" : this.state.saving && this.state.passwordState !== "has-danger" ? "success" : "warning"}
                        onClick={(e) => {
                          this.handleSubmit(e);
                        }}
                        size="lg"
                      >
                        <PulseLoader size={3} margin={"8px"} color={"white"} loading={this.state.updating && !errorMessage} />
                        {this.state.passwordState === "has-danger"
                          ? "Password Not Secure"
                          : this.state.password2 === this.state.password1
                          ? this.state.updating
                            ? "Updating"
                            : this.state.TandC || !this.state.passwordTested
                            ? "Update Password"
                            : "Review Terms"
                          : this.state.password2
                          ? "Passwords Don't Match"
                          : "Re-type Password"}
                      </Button>
                      {this.state.token ? (
                        <FormGroup check className="text-left">
                          <Label check>
                            <Input type="checkbox" defaultChecked={this.state.TandC} onChange={(e) => this.handleClick(e)} />
                            <span className="form-check-sign" />I agree to the{" "}
                            <a
                              href="#"
                              style={{ color: astrabrand[0] }}
                              onClick={() => {
                                this.toggleTermsandConditions();
                              }}
                            >
                              terms and conditions
                            </a>
                            .
                          </Label>
                        </FormGroup>
                      ) : null}
                      <Row style={{ marginTop: 12 }}></Row>
                      {this.state.token ? (
                        <div className="pull-right">
                          <NavLink
                            to={{
                              pathname: "/auth/login",
                            }}
                          >
                            <h6 style={{ color: astrabrand[3] }} className="link footer-link">
                              {"To Login Page"}
                            </h6>
                          </NavLink>
                        </div>
                      ) : null}
                    </CardFooter>
                  </Form>
                </Card>
              </Form>
            </Col>
            <Modal isOpen={this.state.TermsandConditions} toggle={this.toggleTermsandConditions} size="lg" modalClassName="modal-black">
              <ModalBody>
                <Terms toggle={() => this.toggleTermsandConditions()} closeModal={() => this.toggleTermsandConditions()}></Terms>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="primary"
                  onClick={() => {
                    this.setState({ TandC: true });
                    this.toggleTermsandConditions("Confirm", this.state.formationid);
                  }}
                >
                  Accept
                </Button>
              </ModalFooter>
            </Modal>
          </Container>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    obj: [...state.obj],
    loading: state.loading,
    token: state.token,
    error: state.error,
    isAuthenticated: state.token !== null,
    changePasswordUrl: state.changePasswordUrl,
    url: state.url,
    userId: state.userId
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onAuth: (username, password) => dispatch(actions.authLogin(username, password)),
    onTryAutoSignup: () => dispatch(actions.authCheckState())
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ChangePassword));
